import { ChangeEvent, useEffect, useState } from 'react';
import queryHooks from '../../common/queryHooks/index.ts';
import M from 'materialize-css';
import mutationHooks from '../../common/mutationHooks/index.ts';
import { toast } from '../../func.ts';
import useCurrentCustomerLocationId from '../../hooks/useCurrentCustomerLocation.ts';

const DataExport = () => {
  const { customerLocationId } = useCurrentCustomerLocationId();

  const initState = () => ({
    customerLocationId: Number(customerLocationId),
    startDate: '',
    endDate: '',
  });

  const [values, setValues] = useState(initState());
  const { data: locations } = queryHooks.customerLocation.useReadAllByUserId();
  const { mutate: exportData } = mutationHooks.settings.useExportData(values);

  const onChange = ({
    target: { id, value },
  }: ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
    setValues(prev => ({ ...prev, [id]: value }));

  useEffect(() => {
    M.FormSelect.init(document.querySelectorAll('select'));
  }, [locations]);

  useEffect(() => {
    const id = Number(customerLocationId);

    setValues(prev =>
      prev.customerLocationId === id
        ? prev
        : { ...prev, customerLocationId: id }
    );
  }, [customerLocationId]);

  const onClick = () => {
    if (!customerLocationId)
      return toast({
        payload: {
          msg: 'Customer Location is Required',
          class: 'red white-text',
        },
      });

    exportData();
  };

  return (
    <div>
      <div
        className="row blue-grey-text text-darken-2"
        style={{ marginTop: '40px' }}
      >
        <p>
          You can export your data from MedTrax using this utility. Depending on
          the timeframe you choose the export may have a lot of data. While
          exports usually take fewer than 5 minutes, they can take up to an hour
          to complete.
        </p>
        <p>
          When the export is finished you will receive an email with a download
          link. That download will contain 3 items:
        </p>
        <ul className="browser-defualt">
          <li>
            1. A data.csv file containing all the SGTINs received as well as
            which EPCIS file they belong to.
          </li>
          <li>
            2. An inbound file with all the EPCIS files received from your
            upstream partners
          </li>
          <li>
            3. An outbound file with all the EPCIS files you sent to downstream
            partners
          </li>
        </ul>
      </div>
      <div className="row">
        <div className="input-field col s6 m3">
          <input
            type="date"
            id="startDate"
            value={values.startDate}
            onChange={onChange}
          />
          <label>Start Date</label>
        </div>
        <div className="row">
          <div className="input-field col s6 m3">
            <input
              type="date"
              id="endDate"
              value={values.endDate}
              onChange={onChange}
            />
            <label>End Date</label>
          </div>
        </div>
        <div className="row">
          <div className="input-field col s12 m4 offset-m8">
            <a
              href="/"
              onClick={ev => {
                ev.preventDefault();
                onClick();
              }}
              className="btn-small blue white-text waves-effect waves-light col s12"
            >
              Export Data
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataExport;
